<template>
  <div :class="$style.frameGroup">
    <h2>{{ title }}</h2>
    <div :class="$style.frameContainer">
      <div :class="$style.formGroup">
        <div>Do you have prior dispatch experience?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.dispatchExperience"
          :options="[
            { id: true, name: 'Yes' },
            { id: false, name: 'No' },
          ]"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>How many years of experience do you have?</div>
        <input
          type="number"
          v-model="form.yearsOfExperience"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>Have you worked for a part 91, 121, or 135 operation?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.dispatcherOperations"
          multi-select
          :options="dispatcherOperationsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>Do you hold an aircraft dispatcher certificate?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.dispatcherCertificateId"
          :options="dispatcherCertificatesList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.spaceBetween">
        <div :class="$style.formGroup">
          <div>Upload a copy of your medical certificate.</div>
        </div>
        <div :class="$style.formGroup">
          <button :class="$style.uploadBtn">Upload</button>
        </div>
      </div>

      <div :class="$style.formGroup">
        <div>How do you handle challenges or setbacks?</div>
        <input
          type="text"
          v-model="form.handleChallenges"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>Select all that you are familiar with?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.dispatcherSkills"
          multi-select
          :options="dispatcherSkillsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          Select one trait you possess that will make you a great dispatcher?
        </div>
        <input
          type="text"
          v-model="form.personalityTrait"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is your shift availability?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.dispatcherShifts"
          multi-select
          :options="dispatcherShiftsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>What tools are you proficient with?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.flightSchoolTools"
          multi-select
          :options="flightSchoolToolsList"
          :placeholder="'Select all that apply...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.formGroup">
        <div>
          What are your long term goals both within and outside of aviation?
        </div>
        <input
          type="text"
          v-model="form.longTermGoals"
          placeholder="Type your answer..."
        />
      </div>

      <div :class="$style.formGroup">
        <div>What is the highest level of education you have achieved?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.educationLevelId"
          :options="educationLevelsList"
          :placeholder="'Choose one...'"
          :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
        />
      </div>

      <div :class="$style.spaceBetween">
        <div :class="$style.formGroup">
          <div>Upload a copy of your resume.</div>
        </div>
        <div :class="$style.formGroup">
          <button :class="$style.uploadBtn">Upload</button>
        </div>
      </div>

      <div :class="$style.spaceBetween">
        <div :class="$style.formGroup">
          <div>Upload a copy of your cover letter.</div>
        </div>
        <div :class="$style.formGroup">
          <button :class="$style.uploadBtn">Upload</button>
        </div>
      </div>

      <div :class="$style.formGroup">
        <div>Are you looking for a part time or full time position?</div>
        <HiloSelect
          :theme="'grey'"
          v-model="form.fullOrPartTimeId"
          :options="fullOrPartTimeList"
          :placeholder="'Choose one...'"
          :customStyle="{
            height: '50px',
            width: '100%',
            padding: '10px',
          }"
        />
      </div>

      <div :class="$style.formGroup">
        <p>Provide two references flight schools can contact:</p>
      </div>

      <div
        :class="$style.flexGroup"
        v-for="(reference, index) in form.references"
        :key="index"
      >
        <div :class="$style.formGroup">
          <div>Reference {{ index + 1 }}:</div>
          <input v-model="reference.name" type="text" placeholder="Name..." />
        </div>
        <div :class="$style.flexGroup" :style="$global.dynamicCols(2)">
          <div :class="$style.formGroup">
            <input
              v-model="reference.phone"
              type="text"
              placeholder="Phone Number..."
            />
          </div>
          <div :class="$style.formGroup">
            <input
              v-model="reference.email"
              type="email"
              placeholder="Email..."
            />
          </div>
        </div>
        <div :class="$style.formGroup">
          <HiloSelect
            :id="'relationshipList' + index"
            :theme="'grey'"
            v-model="reference.relationshipId"
            :options="relationshipsList"
            :placeholder="'Relationship...'"
            :customStyle="{ height: '50px', width: '100%', padding: '10px' }"
          />
        </div>
      </div>

      <div :class="$style.buttonContainer">
        <div :class="$style.nextButton" @click="handleNext">
          <b :class="$style.name">Next</b>
        </div>
        <div :class="$style.backButton" @click="$emit('onPrev')">
          <b :class="$style.name">Back</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import AboutYouAPIService from "@/servicehandlers/AboutYouAPIService";

const aboutYouAPIService = new AboutYouAPIService();
export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  components: {
    HiloSelect,
  },
  data() {
    return {
      form: {
        dispatchExperience: "",
        yearsOfExperience: "",
        dispatcherOperations: [],
        dispatcherCertificateId: "",
        handleChallenges: "",
        dispatcherSkills: [],
        personalityTrait: "",
        dispatcherShifts: [],
        flightSchoolTools: [],
        longTermGoals: "",
        educationLevelId: "",
        fullOrPartTimeId: "",
        references: [
          { name: "", phone: "", email: "", relationshipId: "" },
          { name: "", phone: "", email: "", relationshipId: "" },
        ],
      },
      relationshipsList: [],
      educationLevelsList: [],
      fullOrPartTimeList: [],
      dispatcherOperationsList: [],
      dispatcherCertificatesList: [],
      dispatcherSkillsList: [],
      dispatcherShiftsList: [],
      flightSchoolToolsList: [],
      loading: false,
    };
  },
  mounted() {
    this.getAboutYouLists();
  },
  methods: {
    async getAboutYouLists() {
      try {
        [
          this.relationshipsList,
          this.educationLevelsList,
          this.fullOrPartTimeList,
          this.dispatcherOperationsList,
          this.dispatcherCertificatesList,
          this.dispatcherSkillsList,
          this.dispatcherShiftsList,
          this.flightSchoolToolsList,
        ] = await Promise.all([
          aboutYouAPIService.getRelationshipsList(),
          aboutYouAPIService.getEducationLevelsList(),
          aboutYouAPIService.getFullOrPartTimeList(),
          aboutYouAPIService.getDispatcherOperationsList(),
          aboutYouAPIService.getDispatcherCertificatesList(),
          aboutYouAPIService.getDispatcherSkillsList(),
          aboutYouAPIService.getDispatcherShiftsList(),
          aboutYouAPIService.getFlightSchoolToolsList(),
        ]);
        this.flightSchoolToolsList = this.flightSchoolToolsList.filter(
          (role) => role.aboutYouDispatcher,
        );
        this.relationshipsList = this.relationshipsList.filter(
          (relationship) => relationship.abtYouDispatch,
        );
      } catch (error) {}
    },
    async handleNext() {
      try {
        this.loading = true;
        const aboutYouData = {
          ...this.form,
          dispatchExperience: this.form.dispatchExperience === "yes",
          userId: this.userId,
        };

        if (this.userId)
          await aboutYouAPIService.createOrUpdateDispatcher(aboutYouData);
        this.$emit("onNext", { aboutYou: this.form });
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style module scoped>
.buttonContainer {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.buttonContainer div {
  align-self: stretch;
  border-radius: 10px;
  height: 50px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  color: #fff;
  transition: 0.2s ease-in-out;
}

.buttonContainer div:hover {
  opacity: 0.8;
}

.nextButton {
  background-color: #3c78ff;
}

.backButton {
  background-color: #ccc;
}
.frameGroup {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.uploadBtn {
  width: fit-content;
  align-items: end;
}

.flexGroup {
  display: grid;
  gap: 10px;
}

.spaceBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.formGroup {
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
}

.formGroup p {
  font-size: 16px;
}

.frameContainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 25px;
}
</style>
